import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

type SincronizarQtdSemanasCotasAptoResponse = {
  aptoId?: number;
  qtdSemanasAno?: number | null;
  totalCotasAtualizadas?: number;
  message?: string;
};

export const sincronizarQtdSemanasCotasAptoService = async (
  aptoId: number
) => {
  const token = validateToken();

  if (!token) {
    throw new Error("Token invalido");
  }

  const url = `${Globais.DOMINIOBACK}/cota/apto/${aptoId}/sincronizar-qtd-semanas`;

  try {
    const response = await axios.post<SincronizarQtdSemanasCotasAptoResponse>(
      url,
      {},
      {
        headers: { Authorization: token.AuthStr },
      }
    );

    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao sincronizar qtdSemanas das cotas do apartamento");
  }
};
